import $ from "jquery";
import { loadScript } from "../../common/load-script";

const WIDGET_DEV_1_KEY = "0x4AAAAAAAguBkwCLl34WPfE";
const WIDGET_PROD_1_KEY = "0x4AAAAAAAiUTkvrWJuSDKCS";
const WIDGET_PROD_2_KEY = "0x4AAAAAAAiUTXPe4qOERc2E";

const SITE_WIDGETS = [
  {
    key: WIDGET_DEV_1_KEY,
    domains: [
      "twbox.io",
      "twtest.io"
    ]
  },
  {
    key: WIDGET_PROD_1_KEY,
    domains: [
      "treatwell.at",
      "treatwell.be",
      "treatwell.de",
      "treatwell.es",
      "treatwell.fr",
      "treatwell.gr",
      "treatwell.ie",
      "treatwell.it",
      "treatwell.lt",
      "treatwell.nl"
    ]
  },
  {
    key: WIDGET_PROD_2_KEY,
    domains: [
      "treatwell.ch",
      "treatwell.co.uk",
      "treatwell.pt"
    ]
  }
];
const initialisation = $.Deferred();
let rejectTimeout;
let state = "uninitialised";
let lastToken = null;

function init () {
  $(".cf-turnstile-container").addClass("active");
  $(".form-action button").attr("disabled", true);
  window.turnstileCallback = () => {
    let domain = window.location.hostname;
    window.turnstile.render(".ui-page-active .cf-turnstile-container", {
      sitekey: getSitekey(domain),
      theme: "light",
      callback: (token) => {
        lastToken = token;
        initialisation.resolve(token);
        clearTimeout(rejectTimeout);
        $(".form-action button").removeAttr("disabled");
        state = "hasToken";
      },
      "error-callback": () => {
        state = "error";
        lastToken = null;
      },
      "before-interactive-callback": () => {
        $(".form-action button").attr("disabled", true);
        state = "interactive";
        lastToken = null;
      },
      "after-interactive-callback": () => {
        state = "initialised";
      }
    });
  };
  state = "initialised";

  loadScript("https://challenges.cloudflare.com/turnstile/v0/api.js?onload=turnstileCallback").catch(
    initialisation.reject
  );
}

function getToken () {
  return new Promise((resolve, reject) => {
    if (lastToken) {
      resolve(lastToken);
    }
    if (["uninitialised", "error", "interactive"].includes(state)) {
      reject(state);
    }
    rejectTimeout = setTimeout(() => {
      reject("getToken() timed out");
    }, 5000);
    initialisation.then((token) => {
      resolve(token);
    }).fail((reason) => {
      reject(reason);
    });
  });
}

function getState () {
  return state;
}

function getSitekey (domain) {
  const widget = SITE_WIDGETS.find(({ domains }) =>
    domains.find((widgetDomain) => domain.endsWith(widgetDomain))
  );
  return widget ? widget.key : null;
}

export {
  init, getToken, getSitekey, WIDGET_PROD_1_KEY, WIDGET_DEV_1_KEY, WIDGET_PROD_2_KEY, getState
};
